export * from './layout';

const hasOwnProperty = Object.prototype.hasOwnProperty;
export const HasOwn = (obj, key) => hasOwnProperty.call(obj, key);